var path = 'ui-formly/types/readonly/index.html';
var html = "<div class=\"form-control-static\">\r\n  {{::displayValue}}\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;